module.exports = __webpack_public_path__ + "img/HomeMAC1100.38267d93.jpg";